import avifTestImage from "../assets/avif-test.avif"; 

export function checkAvifSupport() { 
    return new Promise((resolve) => {

        const cachedSupport = localStorage.getItem("supportsAvif");

        if (cachedSupport !== null) {
            resolve(cachedSupport === "true"); 
            return;
        }

        try {
            const img = new Image();
            let resolved = false;
            img.src = avifTestImage;  

            img.onload = () => {
                if (!resolved) {
                    localStorage.setItem("supportsAvif", "true");
                    resolved = true;
                    resolve(true);
                }
            };

            img.onerror = () => {
                if (!resolved) {
                    //console.log("AVIF Image failed to load!");
                    localStorage.setItem("supportsAvif", "false");
                    resolved = true;
                    resolve(false);
                }
            };

        } catch (error) {
            //console.error("ERROR: Something went wrong in AVIF test:", error);
            resolve(false);
        }
    }); 
}

//Extract Thumbnail Processing


export function getOptimizedThumbnail(thumbnailPath, width) {
  if (!thumbnailPath || typeof thumbnailPath !== 'string') return null;

  const originalExt = thumbnailPath.split('.').pop().toLowerCase(); // jpg, jpeg, png, etc.
  const basePath = thumbnailPath.replace(/\.[^/.]+$/, ''); // remove extension
  const parts = basePath.split('/');
  const baseFilename = parts.pop().replace(/-1k$/, ''); // normalize
  const year = parts[parts.length - 2] || 'unknown';
  const month = parts[parts.length - 1] || 'unknown';

  const urlPrefix = `/uploads/${year}/${month}/${baseFilename}`;

  return {
    avif: `${urlPrefix}-1k.avif`,
    avifMobile: `${urlPrefix}-400.avif`,
    webp: `${urlPrefix}.webp`,
    fallback: `${urlPrefix}.${originalExt}`,
  };
}

export function getSsrOptimizedThumbnail(thumbnailPath) {
  if (!thumbnailPath || typeof thumbnailPath !== 'string') return null;

  const originalExt = thumbnailPath.split('.').pop().toLowerCase();
  const basePath = thumbnailPath.replace(/\.[^/.]+$/, '');
  const parts = basePath.split('/');
  const baseFilename = parts.pop().replace(/-1k$/, '');
  const year = parts[parts.length - 2] || 'unknown';
  const month = parts[parts.length - 1] || 'unknown';

  const urlPrefix = `/uploads/${year}/${month}/${baseFilename}`;

  return {
    avif: `${urlPrefix}-1k.avif`,
    avifMobile: `${urlPrefix}-400.avif`,
    webp: `${urlPrefix}.webp`,
    fallback: `${urlPrefix}.${originalExt}`,
  };
}



